import { render, staticRenderFns } from "./SGShardedClusterConfig.vue?vue&type=template&id=5453ae38"
import script from "./SGShardedClusterConfig.vue?vue&type=script&lang=js"
export * from "./SGShardedClusterConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports